export enum FileType {
    CSV,
    JPEG,
    JPG,
    PDF,
    PNG,
    XLS,
    XLSX
}

